const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Risolve URL immagini Lounge: assoluti restano invariati, i path /api/... vengono
// prefissati col backend (immagini caricate su object storage servite pubblicamente).
export const resolveLoungeUrl = (u) => {
  if (!u) return "";
  return u.startsWith("http") ? u : `${BACKEND}${u}`;
};

export const LOUNGE_LANGS = [
  { code: "it", label: "Italiano" },
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
];

export const LOUNGE_INTRO_FIELDS = [
  { key: "story_title", label: "Storia — Titolo" },
  { key: "story_p", label: "Storia — Testo", area: true },
  { key: "perf_title", label: "Performance — Titolo" },
  { key: "perf_p", label: "Performance — Testo", area: true },
  { key: "life_title", label: "Lifestyle — Titolo" },
  { key: "life_p", label: "Lifestyle — Testo", area: true },
];
